module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-002.b18fccb8.jpg";